/* 
 * Simple editor component that takes placeholder text as a prop 
 */
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // ES6
import './Editor.css';

const  Editor = ({editorState, onEditorStateChange, readOnly, placeholder}) => {
      return (
        <div>
          <ReactQuill 
            theme={'snow'}
            id={`${readOnly === true ? 'editoridreadOnly' : 'editorid'}`}
            style={{height: readOnly === true && 'auto', marginBottom: 30}}
            className="editorQuill"
            onChange={onEditorStateChange}
            value={editorState ? editorState : ""}
            modules={Editor.modules}
            readOnly={readOnly === true ? readOnly : false}
            // formats={Editor.formats}
            bounds={'.app'}
            placeholder={placeholder ? placeholder : ""}
           />
         </div>
       )
  }
  
  /* 
   * Quill modules to attach to editor
   * See https://quilljs.com/docs/modules/ for complete options
   */
  Editor.modules = {
    toolbar: [
      ['bold', 'italic'],
      [{ 'header': '1'}, {'header': '2'}],
      [{size: []}],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      ['link'],
    //   ['clean']
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    }
  }
  /* 
   * Quill editor formats
   * See https://quilljs.com/docs/formats/
   */
  Editor.formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video'
  ]
  
  /* 
   * PropType validation
   */
//   Editor.propTypes = {
//     placeholder: PropTypes.string,
  //}
  
  /* 
   * Render component on page
   */
  

   export default Editor;